import { AppProps } from "next/app";
import { Urbanist } from "next/font/google";
import "../styles/globals.css";

const urbanist = Urbanist({ weight: "700", subsets: ["latin"] });

export default function App({ Component, pageProps }: AppProps) {
  return (
    <main className={urbanist.className}>
      <Component {...pageProps} />
    </main>
  );
}